export function hasPermission(permissions, permissionConstant) {
  return !!permissions?.some?.(
    permission => permissionConstant === permission.id,
  );
}

export function hasAllPermissions(permissions, ...permissionsConstants) {
  return permissionsConstants.every(item => hasPermission(permissions, item));
}

export function hasAnyPermission(permissions, ...permissionsConstants) {
  return permissionsConstants.some(item => hasPermission(permissions, item));
}

export function getSubjectDisplayName(subject) {
  if (subject.displayName) {
    return subject.displayName;
  }
  if (subject.firstName || subject.lastName) {
    return `${subject.firstName} ${subject.lastName}${
      subject.targetName ? ` (${subject.targetName})` : ''
    }`;
  }

  return subject.targetName || subject.name;
}
